import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { ApiService } from '../services/api.service';
import { SocketioService } from '../services/socketio.service';
import { RecordingService } from '../services/recording.service';
import { AlertMessageService } from '../alerts/alertmsg.service';
import { Router } from '@angular/router';
// declare const faceapi: any;

@Component({
  selector: 'app-localvideo',
  templateUrl: './localvideo.component.html',
  styleUrl: './localvideo.component.scss',
})
export class LocalvideoComponent implements OnInit, AfterViewInit {
  gettingUserMedia: boolean = false;
  getUserMediaAttempts = 5;
  video_tracks: MediaStreamTrack;
  recorder: RecordingService;

  @ViewChild('localVideo') private localVideo: ElementRef<HTMLVideoElement>;

  constructor(
    private ss: SocketioService,
    public apiservice: ApiService,
    private router: Router,
    private recordingService: RecordingService,
    private alertMsg: AlertMessageService
  ) {
    this.recorder = this.recordingService;
  }

  ngOnInit(): void {
    this.setupSocketListeners();
  }

  ngAfterViewInit(): void {
    this.initializeLocalVideoStream();
  }

  setupSocketListeners() {
    this.ss.socket.on('host', (isHost: boolean) => {
      this.getUserMediaDevices();
    });

    this.ss.socket.on('ready', async (user: any) => {
      if (
        !(this.localVideo.nativeElement instanceof HTMLVideoElement) ||
        !this.localVideo.nativeElement.srcObject
      ) {
        return;
      }

      this.updateUserData(user);
      const peerConnection = this.createPeerConnection(user);

      this.setupPeerConnectionListeners(peerConnection, user);
    });

    this.ss.socket.on('offer', async (user, description) => {
      let peerConnection = new RTCPeerConnection(this.apiservice.config);
      this.apiservice.peerConnections[user.id] = peerConnection;
      this.apiservice.makeOffer = false;

      if (this.localVideo.nativeElement instanceof HTMLVideoElement) {
        (<MediaStream>this.localVideo.nativeElement.srcObject)
          .getTracks()
          .forEach((track) => {
            peerConnection.addTrack(
              track,
              <MediaStream>this.localVideo.nativeElement.srcObject
            );
          });
      }

      if (
        !(<MediaStream>(
          this.localVideo.nativeElement.srcObject
        )).getVideoTracks()[0] &&
        this.apiservice.validation.call_type === 'video_call'
      ) {
        this.video_tracks = (<MediaStream>(
          this.localVideo.nativeElement.srcObject
        )).getVideoTracks()[0];
        (<MediaStream>this.localVideo.nativeElement.srcObject).addTrack(
          this.video_tracks
        );

        (<MediaStream>this.localVideo.nativeElement.srcObject)
          .getVideoTracks()
          .forEach((track) => {
            peerConnection.addTrack(
              track,
              <MediaStream>this.localVideo.nativeElement.srcObject
            );
          });

        let sender = peerConnection.getSenders().find((s) => {
          if (s.track !== null) {
            return (
              s.track.kind ==
              (<MediaStream>(
                this.localVideo.nativeElement.srcObject
              )).getVideoTracks()[0].kind
            );
          } else {
            return null;
          }
        });

        peerConnection.removeTrack(sender);

        (<MediaStream>this.localVideo.nativeElement.srcObject).removeTrack(
          (<MediaStream>(
            this.localVideo.nativeElement.srcObject
          )).getVideoTracks()[0]
        );
      }

      peerConnection.onicecandidate = (event) => {
        try {
          if (event.candidate) {
            let candidate = new RTCIceCandidate(event.candidate);
            this.ss.socket.emit('candidate', user.id, candidate);
          }
        } catch (error) {
          console.log(error);
        }
      };

      peerConnection.onnegotiationneeded = async () => {
        if (this.apiservice.makeOffer) {
          const offer = await peerConnection.createOffer();
          await peerConnection.setLocalDescription(offer);
          this.ss.socket.emit('answer', user.id, offer);
        } else if (description.type === 'offer') {
          const remoteDesc = new RTCSessionDescription(description);
          await peerConnection.setRemoteDescription(remoteDesc);
          const answer = await peerConnection.createAnswer();
          await peerConnection.setLocalDescription(answer);
          this.ss.socket.emit('answer', user.id, answer);
        }
      };

      peerConnection.ontrack = (event) => {
        if (!this.apiservice.remote_video) {
          this.handleRemoteStreamAdded(event.streams[0], user);
        }
      };

      peerConnection.onicecandidateerror = (event) => {
        console.log('onicecandidateerror ', event);
      };

      peerConnection.onicegatheringstatechange = (event) => {
        console.log(
          'onicegatheringstatechange ',
          peerConnection.iceGatheringState
        );
      };

      peerConnection.oniceconnectionstatechange = () => {
        switch (peerConnection.iceConnectionState) {
          case 'closed':
            console.log('Peers connection closed');
            break;
          case 'failed':
            console.log('Peers connection failed');
            this.apiservice.handleRemoteHangup(user.id);
            break;
          case 'connected':
            console.log('Peers connected');
            break;
        }
      };

      peerConnection.onsignalingstatechange = () => {
        switch (peerConnection.signalingState) {
          // case "closed":
          //     handleRemoteHangup(user.id);
          //     break;
          case 'stable':
            console.log('ICE negotiation complete');
        }
      };
    });

    this.ss.socket.on('stream-added-status', async (status) => {
      try {
        await this.handleStreamAddedStatus(status);
      } catch (error) {
        console.log(error);
      }
    });

    this.ss.socket.on('record-stream-added-status', async (status) => {
      try {
        if (this.apiservice.session_details.ishost && status) {
          setTimeout(
            () =>
              this.recorder.addStream(
                this.localVideo.nativeElement.srcObject,
                this.apiservice.remote_video['stream']
              ),
            2000
          );
          return;
        }
      } catch (error) {}
    });
  }

  createPeerConnection(user: any): RTCPeerConnection {
    const peerConnection = new RTCPeerConnection(this.apiservice.config);
    this.apiservice.peerConnections[user.id] = peerConnection;
    this.apiservice.newOffer = true;
    this.apiservice.makeOffer = false;
    return peerConnection;
  }

  setupPeerConnectionListeners(
    peerConnection: RTCPeerConnection,
    user: any
  ): void {
    const localVideoElement = this.localVideo.nativeElement;

    if (localVideoElement instanceof HTMLVideoElement) {
      const localVideoStream = <MediaStream>localVideoElement.srcObject;
      localVideoStream.getTracks().forEach((track) => {
        peerConnection.addTrack(track, localVideoStream);
      });

      if (
        !localVideoStream.getVideoTracks()[0] &&
        this.apiservice.validation.call_type === 'video_call' &&
        this.apiservice.session_details.video_status
      ) {
        this.video_tracks = localVideoStream.getVideoTracks()[0];

        console.log(
          'this.video_tracks >>> ',
          this.video_tracks,
          localVideoStream.getTracks()
        );

        localVideoStream.addTrack(this.video_tracks);

        localVideoStream.getVideoTracks().forEach((track) => {
          peerConnection.addTrack(track, localVideoStream);
        });

        const sender = peerConnection.getSenders().find((s) => {
          return (
            s.track !== null &&
            s.track.kind == localVideoStream.getVideoTracks()[0].kind
          );
        });

        if (sender) {
          peerConnection.removeTrack(sender);
          localVideoStream.removeTrack(localVideoStream.getVideoTracks()[0]);
        }
      }
    }

    peerConnection.onicecandidate = (event) => {
      try {
        if (event.candidate) {
          const candidate = new RTCIceCandidate(event.candidate);
          this.ss.socket.emit('candidate', user.id, candidate);
        }
      } catch (error) {
        console.log(error);
      }
    };

    peerConnection.onnegotiationneeded = () => {
      this.handleNegotiationNeeded(peerConnection, user);
    };

    peerConnection.ontrack = (event) => {
      if (!this.apiservice.remote_video) {
        this.handleRemoteStreamAdded(event.streams[0], user);
      }
    };

    peerConnection.onicecandidateerror = (event) => {
      console.log('onicecandidateerror', event);
    };

    peerConnection.onicegatheringstatechange = () => {
      console.log(peerConnection.iceGatheringState);
    };

    peerConnection.oniceconnectionstatechange = () => {
      switch (peerConnection.iceConnectionState) {
        case 'closed':
          console.log('Peers connection closed');
          break;
        case 'failed':
          console.log('Peers connection failed');
          this.apiservice.handleRemoteHangup(user.id);
          break;
        case 'connected':
          console.log('Peers connected', peerConnection.getTransceivers());
          break;
      }
    };

    peerConnection.onsignalingstatechange = () => {
      switch (peerConnection.signalingState) {
        case 'stable':
          console.log('ICE negotiation complete');
          break;
      }
    };
  }

  updateUserData(user: any): void {
    if (user.id === this.apiservice.local_view_data.id) {
      this.apiservice.local_view_data.id =
        this.apiservice.session_details.socket_id;
      this.apiservice.local_view_data.audioStatus = user.audioStatus;
      this.apiservice.local_view_data.videoStatus = user.videoStatus;
      this.apiservice.local_view_data.uname = user.uname;
    } else {
      this.apiservice.remote_view_data.id =
        this.apiservice.session_details.socket_id;
      this.apiservice.remote_view_data.audioStatus = user.audioStatus;
      this.apiservice.remote_view_data.videoStatus = user.videoStatus;
      this.apiservice.remote_view_data.uname = user.uname;
    }
  }

  async handleStreamAddedStatus(status: boolean): Promise<void> {
    try {
      const localVideoElement = this.localVideo.nativeElement;

      if (
        !localVideoElement.srcObject ||
        (!(<MediaStream>localVideoElement.srcObject).getVideoTracks()[0] &&
          status)
      ) {
        const newVideo = await navigator.mediaDevices.getUserMedia(
          this.apiservice.validation.call_type === 'video_call'
            ? this.apiservice.video_call_constraints
            : this.apiservice.audio_call_constraints
        );

        const videoStream = newVideo.getVideoTracks()[0];
        videoStream.enabled = false;
        videoStream.stop();

        const localVideoStream = <MediaStream>localVideoElement.srcObject;
        localVideoStream.addTrack(videoStream);

        for (const peerId in this.apiservice.peerConnections) {
          if (peerId) {
            this.apiservice.makeOffer = true;
            await this.apiservice.peerConnections[peerId].addTrack(
              videoStream,
              localVideoStream
            );
          }
        }

        if (this.apiservice.session_details.ishost) {
          setTimeout(
            () =>
              this.recorder.addStream(
                localVideoStream,
                this.apiservice.remote_video['stream']
              ),
            2000
          );
        } else {
          this.ss.socket.emit('record-stream-added-status', true);
        }
      } else if (
        !this.apiservice.remoteVideoRecording &&
        this.apiservice.remote_video &&
        status
      ) {
        this.apiservice.remoteVideoRecording = true;

        if (this.apiservice.session_details.ishost) {
          this.recorder.pauseAndResumeVideoStream([
            this.apiservice.remote_video['stream'],
          ]);
        }
      }
    } catch (error) {
      console.error('Error handling stream added status:', error);
    }
  }

  async handleNegotiationNeeded(
    peerConnection: RTCPeerConnection,
    user
  ): Promise<void> {
    const offer = await peerConnection.createOffer();
    await peerConnection.setLocalDescription(offer);

    if (this.apiservice.makeOffer) {
      this.ss.socket.emit('answer', user.id, offer);
    } else if (this.apiservice.newOffer) {
      this.ss.socket.emit('offer', user.id, offer);
      this.apiservice.newOffer = false;
    }
  }

  initializeLocalVideoStream() {
    this.apiservice.localVideoStream.subscribe((value: MediaStream | any) => {
      if (value) {
        this.localVideo.nativeElement.srcObject = value;
        // if (
        //   this.apiservice.session_details.calltype === 'video_call' &&
        //   this.apiservice.validation.video_call_configurations.emotional_ai
        // ) {
        //   // Emotional-AI
        //   Promise.all([
        //     faceapi.nets.tinyFaceDetector.loadFromUri('assets/models/'),
        //     faceapi.nets.faceLandmark68Net.loadFromUri('assets/models/'),
        //     faceapi.nets.faceRecognitionNet.loadFromUri('assets/models/'),
        //     faceapi.nets.faceExpressionNet.loadFromUri('assets/models/'),
        //     faceapi.nets.ageGenderNet.load('assets/models/'),
        //   ])
        //     .then(value)
        //     .catch((err) => {
        //       console.error('emotional-ai models loading failed', err);
        //     });
        // }
      } else {
        this.stopLocalVideoStream();
      }
    });
  }

  stopLocalVideoStream(): void {
    if (this.localVideo.nativeElement.srcObject) {
      let tracks = (<MediaStream>(
        this.localVideo.nativeElement.srcObject
      )).getTracks();
      tracks.forEach((track) => track.stop());
      this.localVideo.nativeElement.srcObject = null;
    }
  }

  getUserMediaDevices(): void {
    if (
      this.localVideo.nativeElement instanceof HTMLVideoElement &&
      !this.gettingUserMedia &&
      !this.localVideo.nativeElement.srcObject
    ) {
      this.gettingUserMedia = true;
      navigator.mediaDevices
        .getUserMedia(
          this.apiservice.validation.call_type === 'video_call'
            ? this.apiservice.video_call_constraints
            : this.apiservice.audio_call_constraints
        )
        .then((stream) => {
          this.getUserMediaSuccess(stream);
        })
        .catch((error) => {
          this.handleUserMediaError(error);
        });
    }
  }

  getUserMediaSuccess(stream: MediaStream | any): void {
    this.gettingUserMedia = false;
    this.configureLocalVideoStream(stream);

    let user = {
      uname: this.apiservice.session_details.user_name,
      audioStatus: this.apiservice.session_details.audio_status,
      videoStatus: this.apiservice.session_details.video_status,
    };

    this.ss.socket.emit('ready', user);
  }

  configureLocalVideoStream(stream: MediaStream): void {
    if (this.localVideo.nativeElement instanceof HTMLVideoElement) {
      if (this.apiservice.session_details.calltype === 'video_call') {
        if (this.apiservice.session_details.audio_status) {
          stream.getAudioTracks()[0].enabled = true;
        } else {
          stream.getAudioTracks()[0].enabled = false;
        }

        if (this.apiservice.session_details.video_status) {
          stream.getVideoTracks()[0].enabled = true;
        } else {
          if (this.localVideo.nativeElement.srcObject) {
            this.video_tracks = (<MediaStream>(
              this.localVideo.nativeElement.srcObject
            )).getVideoTracks()[0];
            (<MediaStream>this.localVideo.nativeElement.srcObject).removeTrack(
              (<MediaStream>(
                this.localVideo.nativeElement.srcObject
              )).getVideoTracks()[0]
            );
            this.video_tracks.stop();
          }
          stream.getVideoTracks()[0].enabled = false;
          stream.getVideoTracks()[0].stop();
          this.apiservice.pVt = stream.getVideoTracks()[0];
        }
      }

      if (this.apiservice.session_details.calltype === 'audio_call') {
        if (this.apiservice.session_details.audio_status) {
          stream.getAudioTracks()[0].enabled = true;
        } else {
          stream.getAudioTracks()[0].enabled = false;
        }
      }
    }

    console.log('current tracks >>> ', stream.getTracks());

    this.apiservice.localVideoStream.next(stream);
  }

  handleUserMediaError(error: any): void {
    if (error) {
      this.gettingUserMedia = false;
      this.alertMsg.alertWarning('Enable Camera, allow browser permissions');
      this.ss.socket.emit('hangup-remote-call', {
        room: this.apiservice.session_details.roomid,
        session_id: this.apiservice.session_details.session_id,
        status: true,
      });
      if (--this.getUserMediaAttempts > 0) {
        setTimeout(() => {
          this.getUserMediaDevices();
        }, 1000);
      } else {
        this.apiservice.errorPage.next({
          heading: 'Something Went Wrong!',
          message: 'Failed to Capture Camera or Microphone',
        });
        this.router.navigate([
          `/errorpage/${this.apiservice.session_details.session_id}`,
        ]);
      }
    }
  }

  getSupportedVideoMimeTypes() {
    const possibleTypes = [
      'video/webm;codecs=vp9,opus',
      'video/webm;codecs=vp8,opus',
      'video/webm;codecs=h264,opus',
      'video/mp4;codecs=h264,aac',
    ];
    return possibleTypes.filter((mimeType) => {
      return MediaRecorder.isTypeSupported(mimeType);
    });
  }

  getSupportedAudioMimeTypes() {
    const possibleTypes = ['audio/webm;codecs=opus'];
    return possibleTypes.filter((mimeType) => {
      return MediaRecorder.isTypeSupported(mimeType);
    });
  }

  // On remote video Added
  handleRemoteStreamAdded(stream, user) {
    this.apiservice.remote_video = { stream, user };

    console.log('I am in handle remote stream >> ', stream.getTracks(), user);

    if (this.apiservice.session_details.ishost) {
      if (
        this.apiservice.validation.call_type === 'video_call' &&
        this.apiservice.video_call_configurations.recording
      ) {
        this.recorder.init(
          stream,
          this.localVideo.nativeElement.srcObject,
          this.getSupportedVideoMimeTypes()[0]
        );
        if (
          !stream.getVideoTracks()[0] ||
          !(<MediaStream>(
            this.localVideo.nativeElement.srcObject
          )).getVideoTracks()[0]
        ) {
          if (!stream.getVideoTracks()[0]) {
            this.apiservice.remoteVideoRecording = false;
          } else if (
            !(<MediaStream>(
              this.localVideo.nativeElement.srcObject
            )).getVideoTracks()[0]
          ) {
            this.apiservice.localVideoRecording = false;
          }
        }
      }

      if (
        this.apiservice.validation.call_type === 'audio_call' &&
        this.apiservice.audio_call_configurations.recording
      ) {
        this.recorder.init(
          stream,
          this.localVideo.nativeElement.srcObject,
          this.getSupportedAudioMimeTypes()[0]
        );
      }
    }

    this.apiservice.setTime();
    this.apiservice.remote_view_data = user;
    this.apiservice.remoteVideoStream.next(stream);
    if (
      this.apiservice.validation.call_type === 'video_call' &&
      this.apiservice.validation.video_call_configurations.screen_share
    ) {
      this.apiservice.showScreenShare.next(true);
    }
    this.apiservice.createBrowserSessionOnCall();
    this.apiservice.createUserProfile(
      this.apiservice.session_details.user_name,
      this.apiservice.session_details.session_id,
      this.apiservice.session_details.roomid
    );

    // setInterval(async () => {
    //   try {
    //     if (
    //       this.apiservice.validation.call_type === 'video_call' &&
    //       this.apiservice.validation.video_call_configurations.emotional_ai &&
    //       this.apiservice.session_details.video_status &&
    //       <MediaStream>this.localVideo.nativeElement.srcObject &&
    //       (<MediaStream>(
    //         this.localVideo.nativeElement.srcObject
    //       )).getVideoTracks()[0] &&
    //       (<MediaStream>(
    //         this.localVideo.nativeElement.srcObject
    //       )).getVideoTracks()[0].enabled
    //     ) {
    //       const detections = await faceapi
    //         .detectAllFaces(
    //           this.localVideo.nativeElement,
    //           new faceapi.TinyFaceDetectorOptions()
    //         )
    //         .withFaceLandmarks()
    //         .withFaceExpressions()
    //         .withFaceDescriptors()
    //         .withAgeAndGender();
    //       //self datapoints
    //       console.log('detections >>> ', detections);
    //       this.apiservice.self_datapoint.push(detections);
    //       if (!this.apiservice.session_details.ishost) {
    //         this.ss.socket.emit('send-emotional-ai-stats', detections);
    //       }
    //     }
    //   } catch (error) {
    //     console.warn('Emotional ai is on hold!');
    //   }
    // }, 1000);
  }

  //Pause Video Functionality
  pauseOngoingVideo(event: any, user: any) {
    if (!this.apiservice.remote_video && event === true) {
      let stream = (<MediaStream>(
        this.localVideo.nativeElement.srcObject
      )).getVideoTracks();
      stream[0].enabled = false;
      stream[0].stop();

      this.video_tracks = stream[0];
      (<MediaStream>this.localVideo.nativeElement.srcObject).removeTrack(
        this.video_tracks
      );
      this.apiservice.local_view_data = user;
    }

    if (!this.apiservice.remote_video && event === false) {
      this.apiservice.local_view_data = user;
      navigator.mediaDevices
        .getUserMedia(
          this.apiservice.validation.call_type === 'video_call'
            ? this.apiservice.video_call_constraints
            : this.apiservice.audio_call_constraints
        )
        .then((stream) => {
          if (this.localVideo.nativeElement instanceof HTMLVideoElement) {
            if (this.apiservice.local_view_data.audioStatus) {
              stream.getAudioTracks()[0].enabled = true;
            } else {
              stream.getAudioTracks()[0].enabled = false;
            }

            if (this.apiservice.local_view_data.videoStatus) {
              stream.getVideoTracks()[0].enabled = true;
            } else {
              stream.getVideoTracks()[0].enabled = false;
              stream.getVideoTracks()[0].stop();
            }
          }

          this.apiservice.localVideoStream.next(stream);
        });
    }
  }

  //  Mute & unmute Audio Functionality
  Audiomute(event: any, user: any) {
    if (!this.apiservice.remote_video) {
      let audio = <MediaStream>this.localVideo.nativeElement.srcObject;
      let stream = audio.getAudioTracks();
      if (event === true) {
        this.apiservice.local_view_data = user;
        stream[0].enabled = false;
      } else {
        this.apiservice.local_view_data = user;
        stream[0].enabled = true;
      }
    }
  }
}
